'use strict';

var React = require('react');
var headerCheckbox_styles = require('./headerCheckbox.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const HeaderCheckbox = ({ setFilterActive: _setFilterActive, isFilterActive: _isFilterActive, onChange, checked, checkboxProps, ...props }) => (React__default.default.createElement(headerCheckbox_styles.HeaderCheckboxStyled, { ...props },
    React__default.default.createElement("input", { type: "checkbox", title: "select all", onFocus: e => e.stopPropagation(), onChange: onChange, checked: checked, ...checkboxProps })));

exports.HeaderCheckbox = HeaderCheckbox;
//# sourceMappingURL=headerCheckbox.js.map
